import { useRequest } from 'ahooks'
import { useBtc } from '@/context/BtcContext'

const useUnisatInscribeAndTransfer = ({ sendInscriptionFeeRate }: { sendInscriptionFeeRate: number }) => {
  const { isConnected, connectorName } = useBtc()

  return useRequest(
    async (ticker: string, amount: string, receiver: string) => {
      const unisat = (window as any).unisat

      const res1 = await unisat.inscribeTransfer(ticker, amount)
      // console.log('inscribeTransfer:', res1)

      const txid: string = await unisat.sendInscription(receiver, res1.inscriptionId, {
        feeRate: sendInscriptionFeeRate,
      })
      // console.log('sendInscription txid:', txid)

      return {
        inscribeTransfer: res1,
        sendInscription: txid,
      }
    },
    {
      manual: true,
      ready: isConnected && connectorName === 'Unisat',
    },
  )
}

export default useUnisatInscribeAndTransfer
